import { render } from "./categories_component.vue?vue&type=template&id=af597a0e&scoped=true"
import script from "./categories_component.vue?vue&type=script&lang=js"
export * from "./categories_component.vue?vue&type=script&lang=js"

import "./categories_component.vue?vue&type=style&index=0&id=af597a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af597a0e"]])

export default __exports__